var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.499H9V10.999H3V12.499ZM3 9.49902H9V7.99902H3V9.49902ZM1.5 15.499C1.0875 15.499 0.734375 15.3521 0.440625 15.0584C0.146875 14.7646 0 14.4115 0 13.999V1.99902C0 1.58652 0.146875 1.2334 0.440625 0.939648C0.734375 0.645898 1.0875 0.499023 1.5 0.499023H7.5L12 4.99902V13.999C12 14.4115 11.8531 14.7646 11.5594 15.0584C11.2656 15.3521 10.9125 15.499 10.5 15.499H1.5ZM6.75 5.74902V1.99902H1.5V13.999H10.5V5.74902H6.75Z",
    fill: "#9AA0A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/Paper.443fbe88af53793695f3fdcfdc05f234.svg";
export { ForwardRef as ReactComponent };